import React, {useState, useEffect} from 'react';
import http from '../../api/http';
import Editor from '../../components/CKEditor/editor';
import {timeAgo} from '../../components/layouts/mainLayout/HeaderRight';

const getFiles = () => {
    try {
        return JSON.parse(localStorage.getItem('files_gen') || '') || []
    } catch (e) {
        console.log('eeeeeeeeee', e)
        return [0, 1, 2, 3, 4, 5].map(it => {
            return ''
        })
    }
}

const generateVariations = (arrays: any) => {
    const result: any[] = [];

    // Helper function to recursively generate variations
    function generate(index:any, current: any) {
        if (index === arrays.length) {
            result.push(current.slice());
            return;
        }

        for (let i = 0; i < arrays[index].length; i++) {
            current.push(arrays[index][i]);
            generate(index + 1, current);
            current.pop();
        }
    }

    generate(0, []);

    return result;
}

const GeneratorPage = () => {
    const [files, setFiles] = useState(getFiles());

    let arr = files.map((it: any) => {
        return it.split('\n').filter((it: any) => String(it || '').trim() != '')
    }).filter((it: any) => it.length)
    let variations: any[] = generateVariations(arr)
    console.log("qqqqq variations",variations, arr );

    return (
        <div className="admin-config">
            {(files || []).map((it: any, ind: any) => {
                return (<div key={ind} style={{display: 'inline-block', width: '32%', padding: '5px', boxSizing: 'border-box'}}>
                    <textarea
                        value={files[ind]}
                        style={{width: '100%', height: '100px', border: '1px solid #dedede'}} onChange={(e) => {
                        files[ind] = e.target.value;
                        localStorage.setItem('files_gen', JSON.stringify(files))
                        setFiles([...files])
                    }}></textarea>
                </div>)
            })}

            {/*<div style={{borderTop: '1px solid lightgrey', margin: '40px 0'}}></div>*/}
            <div></div>
            <table className={'tableGen'}>
            {(variations || []).map((it, ind) => {
                return (<tr key={ind}>
                    <td>
                        <strong>#{ind + 1}</strong></td>
                    {(it || []).map((it2: any) => {
                        return (<td key={ind}>
                            {it2}
                        </td>)
                    })}
                </tr>)
            })}
            </table>
        </div>
    );
}

export default GeneratorPage;